import {HiveAudios} from 'widgets/hiveAudios';
import {useHivesSoundsStore} from '../../../entities/hiveSound';
import {useApiariesStore} from 'entities/apiaries';
import {useEffect, useState} from 'react';
import {HiveSoundsItem} from 'entities/hiveSound/model/types.ts';

export const HiveAudiosPage = () => {
  const [audioRecords, setAudioRecords] = useState<HiveSoundsItem[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const size = 5;

  const currentApiaryId = useApiariesStore((s) => s.currentApiaryId);
  const getAudiosFromServer = useHivesSoundsStore((s) => s.getAudiosFromServer);

  useEffect(() => {
    if (currentApiaryId) {
      (async () => {
        const {items, total} = await getAudiosFromServer(currentApiaryId, page, size);
        setAudioRecords(items);
        setTotalItems(total);
      })();
    }
  }, [currentApiaryId, page, size]);

  useEffect(() => {
    const totalPages = Math.ceil(totalItems / size);

    if (page > 0 && page >= totalPages) {
      setPage(totalPages - 1);
    }
  }, [totalItems]);

  return (
    <HiveAudios
      audioRecords={audioRecords}
      pagination={{
        page,
        onChange: setPage,
        totalPages: Math.ceil(totalItems / size),
      }}
    />
  );
};
